import React, { useState, useMemo } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import {
    ExpandMore,
    ExpandLess,
    Logout,
    Dashboard,
    AccountCircle,
    Description,
    Receipt,
    Settings,
} from "@mui/icons-material";
import {
    Box,
    Typography,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    Divider,
    Button,
} from "@mui/material";

const AccountsSidebar = () => {
    const [expandedMenu, setExpandedMenu] = useState(null);
    const navigate = useNavigate();
    const { id } = useParams();

    const toggleMenu = (menuName) => {
        setExpandedMenu(expandedMenu === menuName ? null : menuName);
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userType");
        navigate("/accounts/secure/login");
    };

    // Sidebar menu items
    const menuItems = useMemo(
        () => [
            { name: "Dashboard", path: `/accounts/secure/dashboard`, icon: <Dashboard /> },
            { name: "crewing", path: `/accounts/secure/crewing`, icon: <Receipt /> },
            // {
            //     name: "Invoices",
            //     icon: <Receipt />,
            //     subMenu: [
            //         { name: "Create Invoice", path: `/accounts/secure/invoice/create` },
            //         { name: "Invoice List", path: `/accounts/secure/invoice/list` },
            //     ],
            // },
            {
                name: "Invoices",
                icon: <Description />,
                subMenu: [
                    { name: "Save Monthly Invoices", path: `invoices/monthly` },
                    { name: "Crewing Agents Invoices", path: `invoices/crewingAgents` },
                ],
            },
            {
                name: "Settings",
                icon: <Settings />,
                subMenu: [
                    { name: "Profile Settings", path: `/accounts/secure/settings/profile` },
                    { name: "System Settings", path: `/accounts/secure/settings/system` },
                ],
            },
        ],
        []
    );

    return (
        <Box
            sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                p: 2,
                color: "black",
            }}
        >

            {/* Sidebar Header */}
            <Typography
                variant="subtitle1"
                fontWeight="bold"
                textAlign="center"
                mb={2}
                sx={{ color: "black" }}
            >
                Accounts Panel
            </Typography>

            {/* Menu Items */}
            <List component="nav">
                {menuItems.map((item, index) => (
                    <Box key={index}>
                        {item.subMenu ? (
                            <>
                                {/* Parent Menu */}
                                <ListItemButton
                                    onClick={() => toggleMenu(item.name)}
                                    sx={{
                                        borderRadius: 2,
                                        p: 1.5,
                                        "&:hover": {
                                            bgcolor: "grey.100",
                                            color: "primary.main",
                                            "& svg": { color: "primary.main" },
                                        },
                                    }}
                                >
                                    <ListItemIcon sx={{ color: "primary.main", minWidth: 36 }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={item.name} />
                                    {expandedMenu === item.name ? (
                                        <ExpandLess sx={{ color: "primary.main" }} />
                                    ) : (
                                        <ExpandMore sx={{ color: "primary.main" }} />
                                    )}
                                </ListItemButton>

                                {/* Sub Menu */}
                                <Collapse in={expandedMenu === item.name} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding sx={{ pl: 3 }}>
                                        {item.subMenu.map((subItem, subIndex) => (
                                            <ListItemButton
                                                key={subIndex}
                                                component={Link}
                                                to={subItem.path}
                                                sx={{
                                                    borderRadius: 2,
                                                    px: 2,
                                                    py: 1,
                                                    "&:hover": { bgcolor: "grey.400" },
                                                    color: "black",
                                                }}
                                            >
                                                <ListItemText primary={subItem.name} />
                                            </ListItemButton>
                                        ))}
                                    </List>
                                </Collapse>
                            </>
                        ) : (
                            // Direct menu link
                            <ListItemButton
                                component={Link}
                                to={item.path}
                                sx={{
                                    borderRadius: 2,
                                    p: 1.5,
                                    "&:hover": {
                                        bgcolor: "grey.100",
                                        color: "primary.main",
                                        "& svg": { color: "primary.main" },
                                    },
                                }}
                            >
                                <ListItemIcon sx={{ color: "primary.main", minWidth: 36 }}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.name} />
                            </ListItemButton>
                        )}
                    </Box>
                ))}

                <Divider sx={{ my: 2 }} />

                {/* Logout */}
                <Button
                    fullWidth
                    startIcon={<Logout />}
                    onClick={handleLogout}
                    sx={{
                        color: "red",
                        borderRadius: 2,
                        p: 1.5,
                        textAlign: "left",
                        justifyContent: "flex-start",
                        "&:hover": { bgcolor: "error.main", color: "white" },
                    }}
                >
                    Logout
                </Button>
            </List>
        </Box>
    );
};

export default AccountsSidebar;
